import { Component } from '@angular/core';
import { NavController, NavParams, ToastController } from 'ionic-angular';
import { FormBuilder, Validators } from '@angular/forms';
import { AuthServices } from "../../auth/services";
import { SetupInital2Page } from "../setup-initial-2/setup-inital-2";
import { Globals } from "../../../globals";
import { TranslateService } from '@ngx-translate/core';

/**
 * Generated class for the SetupPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-setup',
  templateUrl: 'setup.html',
})
export class SetupPage {

  public form: any;
  public _address: any;
  type: number = 0;
  type_msg: string = '';

  constructor(public fb: FormBuilder,
    public navCtrl: NavController,
    public navParams: NavParams,
    private authServices: AuthServices,
    private toastCtrl: ToastController,
    private globals: Globals,
    public translate: TranslateService) {

    this.form = fb.group({
      address: [''],
      business: ['', Validators.compose([Validators.required])],
      business2: ['',],
      cuisine: [''],
      cuisine2: ['',],
      lang: [(this.globals.restaurant.lang || this.globals.returnLangBrowser(this.translate.getBrowserLang()))],
      buyer_person: [''],
      stores: ['', Validators.compose([Validators.required])],
      workers: ['', Validators.compose([Validators.required])],
      new_business: ['', Validators.compose([Validators.required])],
      worked_so_far: ['', Validators.compose([Validators.required])],
    });
  }

  saveForm() {
    if (!this.form.valid) {
      let toast = this.toastCtrl.create({
        message: this.translate.instant('instant-rellena-todos-campos-formulario'),
        duration: 3000,
        position: 'top'
      });
      toast.present();
    } else {
      if (this.form.value.stores == '1' || this.form.value.stores == '2') {
        this.form.value.buyer_person = 'Montse';
      } else {
        this.form.value.buyer_person = 'Dani';
      }
      //guardamos las variables en globals para tenerlas en las siguientes paginas
      this.globals.restaurant.business = this.type.toString();
      this.globals.register_business = this.type_msg;
      this.globals.register_stores = this.form.value.stores;
      this.globals.register_workers = this.form.value.workers;
      this.globals.register_new_business = this.form.value.new_business;
      this.globals.register_worked_so_far = this.form.value.worked_so_far;
      this.globals.register_buyer_person = this.form.value.buyer_person;
      this.updateData();
    }
  }

  async updateData() {
    this.authServices.afs.collection('restaurants').doc(this.globals.restaurant_uid).update({
      //address: this.form.value.address,
      business: this.type,
      business2: this.form.value.business2,
      cuisine: this.form.value.cuisine,
      cuisine2: this.form.value.cuisine2,
      lang: this.form.value.lang,
      buyer_person: this.form.value.buyer_person,
      register_step: 'setup2',
      plg_register_stores: this.globals.register_stores,
      plg_register_workers: this.globals.register_workers,
      plg_register_new_business: this.globals.register_new_business,
      plg_register_is_digital: this.globals.register_worked_so_far,
    }).then(async value => {
      //Send to bigquery
      this.globals.sendToBigqueryRegister('setup1');
      this.navCtrl.push(SetupInital2Page);
    });
  }

  addres_format_google: any;
  public handleAddressChange(address) {
    this.addres_format_google = address.formatted_address;
    this.form.value.address = address.formatted_address;
  }

  selectType(type) {
    switch (type) {
      case '2':
        this.type = 2;
        this.type_msg = 'Bar';
        break;
      case '1':
        this.type = 1;
        this.type_msg = 'Restaurante';
        break;
      case '10':
        this.type = 10;
        this.type_msg = 'Para llevar';
        break;
      case '3':
        this.type = 3;
        this.type_msg = 'Catering';
        break;
      case '13':
        this.type = 13;
        this.type_msg = 'Otros';
        break;
      case '16':
        this.type = 16;
        this.type_msg = 'Camping';
        break;
    }
  }
}


// WEBPACK FOOTER //
// ./src/pages/setup/setup-initial/setup.ts